<template>
    <div>
        <AlertDismiss ref="alertDismiss"></AlertDismiss>

        <form @submit="onSubmit">
            <div class="row">
                <div class="col-12 col-sm-6 mb-3">
                    <b-form-group
                        label="Nombre"
                        label-for="nombreFormControlInput"
                    >
                        <b-form-input
                            id="nombreFormControlInput"
                            v-model="user.name"
                            type="text"
                            placeholder="Nombres completos"
                            :state="validate(user.name)"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-12 col-sm-6 mb-3">
                    <b-form-group
                        label="Apellido"
                        label-for="apellidoFormControlInput"
                    >
                        <b-form-input
                            id="apellidoFormControlInput"
                            v-model="user.lastName"
                            type="text"
                            placeholder="Apellidos completos"
                            :state="validate(user.lastName)"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-12 col-sm-6 mb-3">
                    <b-form-group
                        label="Correo"
                        label-for="correoFormControlInput"
                    >
                        <b-form-input
                            id="correoFormControlInput"
                            v-model="user.mail"
                            type="email"
                            placeholder="Correo"
                            :state="validate(user.mail)"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-12 col-sm-6 mb-3">
                    <b-form-group
                        label="Confirmar correo"
                        label-for="ConfirmarCorreoFormControlInput"
                    >
                        <b-form-input
                            id="ConfirmarCorreoFormControlInput"
                            v-model="user.mailConfirmar"
                            type="email"
                            placeholder="Repita el correo"
                            :state="validate(user.mailConfirmar)"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-12 col-sm-6 mb-3">
                    <RutInput v-model="user.rut"
                        id="RutFormControlInput"
                        :disabled="true"
                    />
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-sm-6 mb-3">
                    <button type="submit" class="btn btn-outline-primary" :disabled="process">
                        <b-spinner v-if="process" small></b-spinner>
                        Modificar
                    </button>
                </div>
            </div>

        </form>
    </div>
</template>
<script>
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import { mapActions } from 'vuex';
import { EventNames, InitPageSize } from '@/plugins/enums/index.js'
import RutInput from '@/components/shared/RUT-input.vue'
import { validateNonEmpty } from '@/plugins/complianceScripts'; 

export default {
    name: 'EditUserForm',

    components: {
        AlertDismiss,
        RutInput
    },

    props: {
        userProp: {
            type: Object
        }
    },

    data() {
        return {
            user: {
                id: '',
                name: '',
                lastName: '',
                mail: '',
                mailConfirmar: '',
                rut: ''
            },

            attemptedSubmit: false,

            process: false,
        }
    },

    computed: {
        allValuesFilled() {
            return Object.values(this.user).every(x => x != '')
        }
    },

    mounted() {
        this.initValueUser(this.userProp);
    },

    methods: {
        ...mapActions(["modifyUser"]),

        validate(value) {
            return validateNonEmpty(value, this.attemptedSubmit);
        },
        clearForm() {
            this.user.name = '';
            this.user.lastName = '';
            this.user.mail = '';
            this.user.mailConfirmar = '';
            this.user.password = '';
            this.user.passwordConfirmar = '';
            this.user.rut = '';
        },

        initValueUser(user) {
            this.user.id = user.id;
            this.user.name = user.nombre;
            this.user.lastName = user.apellido
            this.user.mail = user.correo;
            this.user.mailConfirmar = user.correo;
            this.user.rut = user.rut;
        },

        processing() {
            this.process = !this.process;
        },

        async onSubmit(event) {
            event.preventDefault();

            this.attemptedSubmit = true
            if (!this.allValuesFilled) {
                this.$refs.alertDismiss.showAlert('Debe completar todos los campos', 'warning');
                return
            } 
            this.attemptedSubmit = false

            this.processing();
            if (this.user.mail != this.user.mailConfirmar) {
                this.$refs.alertDismiss.showAlert('La confirmación del correo no es correcta.');
                this.processing();
                return;
            }

            let result = await this.modifyUser({
                id: this.user.id,
                name: this.user.name,
                lastName: this.user.lastName,
                mail: this.user.mail,
            });

            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message);
                this.processing();
                return;
            }

            this.clearForm();

            this.processing();

            this.$eventBus.$emit(EventNames.ModifyUser, {
                mail: this.user.mail, 
                page: 1, 
                pageSize: InitPageSize.UsersPageSize});

        },
    }

}
</script>
<style></style>
